import React, { Component } from "react";
import Autocomplete from "react-autocomplete";
import API from "../../../apiService.js";
import moment from "moment";
import ALERT from "../../component/Alert";
import { Formik, Form } from "formik";
import * as Yup from "yup";
const SignupSchema = Yup.object().shape({
  icd: Yup.string().required("ICD HARUS DIISI"),
});
export class Assesment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      date: moment(new Date()).format("YYYY-MM-DD"),
      dataIcd: [],
      dataTreatments: [],
      icd: [
        {
          visit_id: "",
          visit_inpatient_detail_id: "",
          icd_code: "",
          icd_name: "",
          explanation: "",
          date: "",
          case: "new",
          elemen_teeth: "",
          log: false,
          examination_type_id: "",
        },
      ],
      treatments: [
        {
          visit_id: "",
          visit_inpatient_detail_id: "",
          treatment_id: "",
          log: "0",
          treatment: { name: "" },
        },
      ],

      value: "",
      icdSelected: "",
      data: props.inpatient.examinations && props.inpatient.examinations.length
          ? props.inpatient.examinations[0]
          : props.existing_examination,
      visit_id: props.visit_id,
      visit_inpatient_detail_id: props.inpatient.id ?? "0",
      diagnostic_narativ: props.inpatient.examinations && props.inpatient.examinations.length > 0 ? props.inpatient.examinations[0].diagnostic_narativ : ''
    };
    this.timeout = 0;
    // Bind `this` context to functions of the class
    this.onChangeIcd = this.onChangeIcd.bind(this);
    this.onSelect = this.onSelect.bind(this);
    this.getItemValue = this.getItemValue.bind(this);
    this.renderItem = this.renderItem.bind(this);
    this.retrieveDataAsynchronouslyIcd =
      this.retrieveDataAsynchronouslyIcd.bind(this);
  }

  componentDidMount() {
    if (this.props.inpatient.diagnoses[0]) {
      this.setState({
        icd: this.props.inpatient.diagnoses && this.props.inpatient.diagnoses.length
          ? this.props.inpatient.diagnoses
          : [
              {
                visit_id: "",
                visit_inpatient_detail_id: "",
                icd_code: "",
                icd_name: "",
                explanation: "",
                date: "",
                case: "new",
                elemen_teeth: "",
                log: false,
                examination_type_id: "",
              },
            ],
      });
    }
    this.icd.focus();
  }

  componentDidUpdate(prevProps) {
    if (this.props.inpatient !== prevProps.inpatient) {
      this.setState({
        date: moment(new Date()).format("YYYY-MM-DD"),
        data:
            this.props.inpatient.examinations && this.props.inpatient.examinations.length > 0
                ? this.props.inpatient.examinations[0]
                : this.props.existing_examination,
        icd: this.props.inpatient.diagnoses && this.props.inpatient.diagnoses.length
            ? this.props.inpatient.diagnoses
            : [
              {
                visit_id: "",
                visit_inpatient_detail_id: "",
                icd_code: "",
                icd_name: "",
                explanation: "",
                date: "",
                case: "new",
                elemen_teeth: "",
                log: false,
                examination_type_id: "",
              },
            ],
        visit_id: this.props.visit_id,
        visit_inpatient_detail_id: this.props.inpatient.id ?? "0",
        diagnostic_narativ: this.props.inpatient.examinations && this.props.inpatient.examinations.length > 0 ? this.props.inpatient.examinations[0].diagnostic_narativ : ''
      })
    }
  }

  handleNameChange = (evt) => {
    this.setState({ name: evt.target.value });
  };

  handleInputNameChangeIcd = (idx) => (evt) => {
    const val = evt.split("_", 3);
    const icpc = this.state.dataIcd.find((e) => e.code === val[0])?.icpc2;
    const newIcd = this.state.icd.map((icd, sidx) => {
      if (idx !== sidx) return icd;
      return {
        visit_id: this.props.inpatient.id,
        visit_inpatient_detail_id: "0",
        icd_code: val[0],
        icd_name: val[1],
        explanation: "",
        date: this.state.date,
        case: "new",
        elemen_teeth: "0",
        log: false,
        examination_type_id: "0",
        icd10: { non_specialist: val[2] },
        icpc2: icpc,
      };
    });

    this.setState({ icd: newIcd });
    setTimeout(
      function () {
        let parent = [];
        parent = { data: this.state.icd, param: "diagnoses" };
        // this.props.parentCallback(parent);
      }.bind(this),
      200
    );
  };

  handleSubmit = (evt) => {
    this.postIcd();
  };

  postIcd = async (e) => {
    await API.put("registration/examination/update", {
      ...this.state.data,
      diagnostic_narativ: this.state.diagnostic_narativ
    });
    const res = await API.post("/management/diagnoses/create", {
      diagnose: this.state.icd.map(v => ({
        ...v,
        visit_inpatient_detail_id: this.state.visit_inpatient_detail_id,
        visit_id: this.state.visit_id
      }))
    });
    if (res.code === 200) {
      ALERT("success", "Berhasil Menyimpan Data ");
      this.props.on_data_saved(res.data, this.state.diagnostic_narativ)
    } else {
      ALERT("error", "gagal menyimpan data");
    }
  };

  handleAddInput = (x) => (evt) => {
    this.setState({
      [evt.target.name]: x,
    });
  };

  handleRemoveInputIcd = (idx) => (evt) => {
    // const val = evt.target.value;
    const icd = [...this.state.icd];
    icd[idx].log = true;
    if (icd[idx].icd_code !== "") {
      this.setState({ icd });
    } else {
      this.setState({
        [evt.target.name]: this.state.icd.filter((s, sidx) => idx !== sidx),
      });
    }
  };

  retrieveDataAsynchronouslyIcd = async (e) => {
    const res = await API.get("management/icd10/read?keyword=" + e);
    if (res.code === 200) {
      this.setState({
        dataIcd: res.data.data,
      });
    } else {
      console.error("Cannot load data from remote source");
    }
  };

  onChangeIcd = (idx) => (evt) => {
    const newIcd = this.state.icd.map((icd, sidx) => {
      if (idx !== sidx) return icd;
      return {
        visit_id: this.props.inpatient.id,
        visit_inpatient_detail_id: "",
        icd_code: "",
        icd_name: evt.target.value,
        explanation: "",
        date: this.state.date,
        case: "new",
        elemen_teeth: "",
        log: false,
        examination_type_id: "",
      };
    });

    this.setState({ icd: newIcd });

    /**
     * Handle the remote request with the current text !
     */
    const par = evt.target.value;
    if (this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      if (par.length > 2) {
        this.retrieveDataAsynchronouslyIcd(par);
      }
    }, 500);
    // if (evt.target.value.length > 2) {
    // setTimeout(event => {
    // this.retrieveDataAsynchronouslyIcd(par);
    // }, 300);
    // console.log("The Input Text has changed to ", par);
    // }
  };

  /**
   * Callback triggered when the autocomplete input changes.
   *
   * @param {Object} val Value returned by the getItemValue function.
   * @return {Nothing} No value is returned
   */
  onSelect(val) {
    this.setState({
      value: val,
    });
    const x = val.split("_", 2);
    console.log("Option from 'database' selected : ", x);
  }

  /**
   * Define the markup of every rendered item of the autocomplete.
   *
   * @param {Object} item Single object from the data that can be shown inside the autocomplete
   * @param {Boolean} isHighlighted declares wheter the item has been highlighted or not.
   * @return {Markup} Component
   */
  renderItem(item, isHighlighted) {
    return (
      <div
        key={item.id}
        style={{ background: isHighlighted ? "lightgray" : "white" }}
      >
        {item.code} _ {item.name} _ [{item.name_en}]
      </div>
    );
  }

  getItemValue(item) {
    // You can obviously only return the Label or the component you need to show
    // In this case we are going to show the value and the label that shows in the input
    // something like "1 - Microsoft"
    return `${item.code}_${item.name}_${item.non_specialist}`;
  }

  onReload = () => {
    this.props.history.push("/pelayanan-ranap");
  };
  chageIcdCase = (idx) => (event) => {
    const target = event.target;
    const icd = [...this.state.icd];
    const value = target.type === "checkbox" ? target.checked : target.value;
    if (value) {
      icd[idx].case = "new";
    } else {
      icd[idx].case = "old";
    }
    this.setState({ icd });
  };

  // examination
  handleChangeText = (event) => {
    const value = event.target.value;
    const object = event.target.name;
    let data;
    this.setState(
      (prevState) => ({
        data: {
          // object that we want to update
          ...prevState.data, // keep all other key-value pairs
          [object]: value, // update the value of specific key
        },
      }),
      () => {
        data = { data: [this.state.data], param: "examinations" };
        // this.props.parentCallback(data);
      }
    );
  };

  render() {
    let DeletedIcd = [];
    this.state.icd.map((icd, idx) => {
      if (icd.log) {
        DeletedIcd[idx] = icd;
      }
    });
    const deletedIcdInformation = DeletedIcd.map((data, key) => {
      return (
        <a key={key} className="dropdown-item">
          {data.icd_code} - {data.icd_name}
        </a>
      );
    });

    return (
      <>
        <Formik
          enableReinitialize
          initialValues={{
            icd: this.state.icd[0].icd_code,
          }}
          validationSchema={SignupSchema}
          onSubmit={(values) => {
            this.handleSubmit();
            this.props.nextTab();
            // same shape as initial values
            // console.log(values);
          }}
        >
          {({ values, errors, touched }) => (
            <Form>
              <div className="form-group row">
                <div className="col-md-5 ">
                  <div className="row">
                    <div className="col-md-6">
                      <label
                        htmlFor="example-text-input"
                        className="col-form-label col-form-label-sm"
                      >
                        Diagnosis
                      </label>
                    </div>
                    {DeletedIcd.length > 0 ? (
                      <div>
                        <div className="col-auto">
                          <button
                            type="button"
                            className="btn btn-sm btn-danger mr-0"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                          >
                            dihapus
                          </button>
                          <div className="dropdown-menu dropdown-menu-left">
                            {deletedIcdInformation}
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div></div>
                    )}
                  </div>
                </div>
                <div className="col-md-7">
                  {this.state.icd.map((icd, idx) => {
                    if (icd.log === false || icd.log === 0)
                      return (
                        <div key={idx} className="form-group row">
                          <Autocomplete
                            inputProps={{
                              className: "form-control form-control-sm",
                              placeholder: "ketikkan minimal 3 huruf diagnosa",
                            }}
                            ref={(input) => {
                              this.icd = input;
                            }}
                            getItemValue={this.getItemValue}
                            items={this.state.dataIcd}
                            renderItem={this.renderItem}
                            value={
                              this.state.icd[idx].icd_name
                                ? this.state.icd[idx].icd_code +
                                  "" +
                                  this.state.icd[idx].icd_name
                                : ""
                            }
                            onChange={this.onChangeIcd(idx)}
                            onSelect={this.handleInputNameChangeIcd(idx)}
                            menuStyle={{
                              borderRadius: "3px",
                              boxShadow: "0 2px 12px rgba(0, 0, 0, 0.1)",
                              background: "rgba(255, 255, 255, 0.9)",
                              padding: "2px 0",
                              fontSize: "90%",
                              // position: "absolute",
                              overflow: "auto",
                              zIndex: "100",
                              maxHeight: "50%", // TODO: don't cheat, let it flow to the bottom
                            }}
                            wrapperStyle={{
                              maxWidth: "81.66667%",
                              flex: "0 0 81.66667%",
                              overflow: "auto",
                            }}
                          />
                          <label className="custom-toggle custom-toggle-success">
                            <input
                              type="checkbox"
                              checked={
                                this.state.icd[idx].case === "new"
                                  ? "checked"
                                  : ""
                              }
                              onChange={this.chageIcdCase(idx)}
                            />
                            <span
                              className="custom-toggle-slider rounded-circle"
                              data-label-off="lama"
                              data-label-on="baru"
                            />
                          </label>
                          <div>
                            <button
                              type="button"
                              className="btn btn-sm btn-danger"
                              style={{ maxWidth: "10%" }}
                              name="icd"
                              onClick={this.handleRemoveInputIcd(idx)}
                            >
                              -
                            </button>
                          </div>
                          <div className="row col-md-12 mt-2">
                            <div className="col-md-3">
                              <label className="form-control-label">
                                ICPC2
                              </label>
                            </div>
                            <div className="col-md-9">
                              <textarea className="form-control form-control-sm" value={icd.icpc2 ? `${icd.icpc2.icpc2_data.code} - ${icd.icpc2.icpc2_data.name}` :''} />
                            </div>
                          </div>
                        </div>
                      );
                  })}
                  <button
                    type="button"
                    name="icd"
                    style={{ marginLeft: "2%" }}
                    onClick={this.handleAddInput(
                      this.state.icd.concat([
                        {
                          visit_id: "",
                          visit_inpatient_detail_id: "",
                          icd_code: "",
                          icd_name: "",
                          explanation: "",
                          date: "2019-02-02",
                          case: "new",
                          elemen_teeth: "",
                          log: false,
                          examination_type_id: "",
                        },
                      ])
                    )}
                    className="btn btn-sm btn-primary"
                  >
                    Add
                  </button>
                  {errors.icd && touched.icd ? (
                    <div style={{ color: "red" }}>{errors.icd}</div>
                  ) : null}
                </div>
              </div>
              <div className="form-group row">
                <label
                  htmlFor="example-text-input"
                  className="col-md-5 col-form-label col-form-label-sm"
                >
                  Diagnosa Naratif
                </label>
                <div className="col-md-7">
                  <div className="row">
                    <textarea
                      className="form-control form-control-sm"
                      type="text"
                      placeholder="Diagnosa naratif"
                      name="diagnostic_narativ"
                      onChange={e => this.setState({diagnostic_narativ: e.target.value})}
                      value={this.state.diagnostic_narativ}
                    />
                  </div>
                </div>
              </div>
              <button className="btn btn-primary" disabled={this.props.disabled}>Simpan</button>
              <button className="btn btn-danger" onClick={this.onReload}>
                Tutup
              </button>
            </Form>
          )}
        </Formik>
      </>
    );
  }
}

export default Assesment;
